/**
 * Gift Card Character Counter
 * Added to a seperate file so that it doesn't bloat the product form and conditionally loads only if the gift card form is present
 */
document.addEventListener('DOMContentLoaded', function() {
  // Show counters after 100ms to prevent customer seeing counters jumping positions on the DOM load
  setTimeout(() => {
    document.querySelectorAll('.Form__Counter').forEach(counter => {
      counter.classList.remove('hidden');
    });
  }, 100);

  if (document.getElementById('gift-card-to-name')) {
    const giftCardFields = Array.from(document.querySelectorAll('[id^="gift-card-"]')).map(el => el.id);

    giftCardFields.forEach(fieldId => {
      // Get all required elements and make sure they exist
      const field = document.getElementById(fieldId);
      if (!field) {
        console.warn(`Gift card field ${fieldId} not found`);
        return;
      }

      const counter = document.getElementById(fieldId + '-counter');
      if (!counter) {
        console.warn(`Counter for ${fieldId} not found`);
        return;
      }

      const formItem = field.closest('.Form__Item');
      if (!formItem) {
        console.warn(`Form item wrapper for ${fieldId} not found`);
        return;
      }

      const counterWrapper = counter.parentElement?.parentElement;
      if (!counterWrapper) {
        console.warn(`Counter wrapper for ${fieldId} not found`);
        return;
      }

      const errorDisplay = formItem.querySelector('.gift-card-counter-error');
      if (!errorDisplay) {
        console.warn(`Error display for ${fieldId} not found`);
        return;
      }

      // Get the character limit from the data attribute
      const limit = parseInt(field.getAttribute('data-char-limit'), 10);
      if (isNaN(limit)) {
        console.warn(`No valid character limit found for ${fieldId}`);
        return;
      }

      // Add event listener to the field
      field.addEventListener('input', function() {
        let value = this.value;
        if (value.length > limit) {
          this.value = value.substring(0, limit);
          value = this.value;
        }
        const length = value.length;
        counter.textContent = length;

        if (length >= limit) {
          errorDisplay.classList.remove('opacity-0', 'pointer-events-none');
          errorDisplay.classList.add('opacity-100', 'pointer-events-auto');
          counterWrapper.classList.add('limit-reached');
        } else {
          errorDisplay.classList.add('opacity-0', 'pointer-events-none');
          errorDisplay.classList.remove('opacity-100', 'pointer-events-auto');
          counterWrapper.classList.remove('limit-reached');
        }
      });
      
      // Initialize counter
      counter.textContent = field.value.length;
    });
  }
});